// skills/crafting/index.js
// Crafting skill registration with skill registry

import { skillRegistry } from '../../core/skillRegistry.js';
import {
    renderCraftingUI,
    renderJewelryUI,
    renderArmorUI,
    renderMagicArmorUI,
    updateCraftingUI,
    initCraftingUI,
    toggleJewelry,
    toggleArmor,
    toggleMagicArmor,
    upgradeTool,
    switchCategory,
    switchArmorTier,
    switchMagicArmorTier,
    switchJewelryType,
    switchTab,
    getCurrentCategory
} from './craftingUI.js';

/**
 * Crafting skill configuration
 * Uses category tabs (Jewelry, Ranged Armor) with tier sub-tabs for armor
 */
const craftingConfig = {
    id: 'crafting',
    name: 'Crafting',
    icon: '✂️',
    iconImage: 'assets/icons/skill_icons/crafting.png',
    description: 'Create jewelry and armor from raw materials',

    // Crafting manages its own category tabs internally (Jewelry, Ranged Armor)
    // Don't use router-level tabs - they interfere with persisted state

    render(params = {}) {
        // If tab provided in URL, use it; otherwise use persisted category
        const tab = params.tab || getCurrentCategory();
        if (tab === 'ranged') {
            renderArmorUI(); // Uses persisted tier selection
        } else {
            renderJewelryUI();
        }
    },

    update() {
        updateCraftingUI();
    },

    init() {
        initCraftingUI();
    },

    cleanup() {
        // Nothing to cleanup for now
    }
};

skillRegistry.register('crafting', craftingConfig);

if (typeof window !== 'undefined') {
    window.craftingUI = {
        toggleJewelry,
        toggleArmor,
        toggleMagicArmor,
        upgradeTool,
        switchCategory,
        switchArmorTier,
        switchMagicArmorTier,
        switchJewelryType,
        switchTab  // Legacy compatibility
    };
}

export default craftingConfig;
